'use client';

import { CategoryType } from '@/types';
import React, { useContext } from 'react';
import { Button, Empty, Tree } from 'antd';
import { IoIosArrowBack } from 'react-icons/io';
import styles from './categories.module.scss';
import { PATH } from 'data';
import { GlobalContext } from '@/context';
import { RenderedCategory } from './categories.type';
import { AppLinkComp } from '@/components';
function CategoriesComp({
  categories
}: {
  categories: CategoryType[];
}) {
  const {
    langText,
    location
  } = useContext(GlobalContext);
  const lang = langText.lang;
  const renderSubCategory = (parent?: CategoryType): RenderedCategory[] => {
    if (!categories.filter(item => item.parent === parent?.slug).length) null;
    return categories.filter(i => i.parent?.slug === parent?.slug).map(item => ({
      title: <AppLinkComp href={PATH(lang).services.category(location.slug, item.slug)} className="t-dark1 w-100 d-block p-1">
                        {item.title}
                    </AppLinkComp>,
      key: item.slug,
      children: renderSubCategory(item),
      disabled: true
    }));
  };
  if (categories.length === 0) return <Empty className="mt-8" description={langText.categories.noData}>
                <AppLinkComp href={PATH(lang).home()}>
                    <Button className="ph-3-i mv-3-i">{langText.categories.back}</Button>
                </AppLinkComp>
            </Empty>;
  return <div className={`${styles['service-filter-layout']}`} data-sentry-component="CategoriesComp" data-sentry-source-file="categories.index.tsx">
            <Tree treeData={categories.filter(i => !i.parent).map(item => ({
      title: <AppLinkComp href={PATH(lang).services.category(location.slug, item.slug)} className="t-dark1 w-100 d-block p-1">
                                {item.title}
                            </AppLinkComp>,
      key: item.slug,
      children: renderSubCategory(item),
      disabled: true
    }))} switcherIcon={<IoIosArrowBack size={16} />} data-sentry-element="Tree" data-sentry-source-file="categories.index.tsx" />
        </div>;
}
export default CategoriesComp;